import React, { useEffect, useState } from "react";
import Popup from "../../../components/common/model/Popup";
import {
  DialogContent,
  DialogContentText,
  Grid,
  Typography,
} from "@mui/material";

import useStyles from "../../../components/common/model/styles";
import CardView from "../../../components/common/CardView";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { getSmsTemplateAction } from "../../../store/reducers/smsTemplateSlice";
import PreviewTemplate from "./PreviewTemplate";
import { setNotificationAction } from "../../../store/reducers/mmymSlice";

interface ManageSmsTemplateProps {
  open: boolean; // Define the 'open' prop
  onHide: () => void; // Define the 'onHide' prop
  title: string; // Define the 'title' prop
  setSelectedTemplate: React.Dispatch<React.SetStateAction<Template | null>>;
}

interface Template {
  id: number;
  title: string;
  body: string;
  event: string;
}

const ManageSmsTemplate: React.FC<ManageSmsTemplateProps> = (props) => {
  const { onHide, open, title } = props;
  const classes = useStyles();

  const { smsTemplates } = useSelector((state: any) => state.smsTemplate);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSmsTemplateAction());
  }, [dispatch]);

  const [isViewSendSms, setIsViewSendSms] = useState(false);
  const [selectedSms, setSelectedSms] = useState<null>(null);
  const handleClickTemplate = (item: any) => {
    // props.onHide();
    setSelectedSms(item);
    setIsViewSendSms(true);
  };

  const closeHandlerView = () => {
    setSelectedSms(null);
    setIsViewSendSms(false);
    dispatch(setNotificationAction({ message: [], severity: "error" }));
  };

  return (
    <>
      <Popup
        open={open}
        fullWidth
        title={title}
        onHide={onHide}
        maxWidth={"lg"}
        popupBg="#fff"
      >
        <DialogContent sx={{ paddingLeft: "20px" }}>
          <DialogContentText className={classes.formAddBox}>
            <Grid container spacing={2} sx={{ marginTop: "10px" }}>
              {smsTemplates ? (
                smsTemplates
                  .filter(
                    (item: Template) =>
                      ![
                        "Onboarding",
                        "Password Reset",
                        "Admin Activation",
                        "Send Promotional Email",
                        "Send Appointment Reminder SMS",
                      ].includes(item.event)
                  )
                  .map((item: Template, i: number) => (
                    <Grid
                      key={i}
                      item
                      xs={12}
                      md={3}
                      style={{
                        padding: "16px 10px",
                        marginBottom: "10px",
                        cursor: "pointer",
                      }}
                      onClick={() => handleClickTemplate(item)}
                    >
                      <>
                        <CardView
                          {...{
                            ...item,
                            isEdit: false,
                            width: "100%",
                            // onEditClick: () => handleEditTemplate(item),
                          }}
                        />
                      </>
                    </Grid>
                  ))
              ) : (
                <Typography variant="h5" style={{ margin: "auto" }}>
                  No Email Templates found
                </Typography>
              )}
            </Grid>
          </DialogContentText>
        </DialogContent>
      </Popup>
      {isViewSendSms && (
        <PreviewTemplate
          open={isViewSendSms}
          onHide={closeHandlerView}
          selectedSms={selectedSms}
          title="Template"
        />
      )}
    </>
  );
};

export default ManageSmsTemplate;
